import styled from 'styled-components';

interface StyledSelectBenefitCardProps {
  isSelected: boolean;
}

export const StyledSelectBenefitCard = styled.div<StyledSelectBenefitCardProps>`
  width: 210px;
  height: 64px;
  cursor: pointer;
  font-size: ${({ theme }) => theme.fontMedium};
  font-weight: ${({ theme }) => theme.fontSemiBold};
  color: ${({ theme }) => theme.primaryFrontColor};
  padding: 0 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${({ theme }) => theme.gray0};
  border: ${({ theme, isSelected }) =>
    isSelected
      ? `2px solid ${theme.primaryFrontColor}`
      : `1px solid ${theme.gray10}`};

  &:hover {
    border-color: ${({ theme, isSelected }) =>
      isSelected ? theme.primaryFrontColor : theme.gray25};
  }
`;
